// extracted by mini-css-extract-plugin
module.exports = {"productForm__color":"styles_productForm__color___9_T5","productForm__colorBadge":"styles_productForm__colorBadge___fTBM"};